// src/context/ThemeContext.jsx

import { createContext, useEffect, useState } from 'react';

// 1) create the context with default values
export const ThemeContext = createContext({
  theme: 'light',
  toggleTheme: () => {}
});

export function ThemeProvider({ children }) {
  // 2) compute initial theme: localStorage > system preference > 'light'
  const getInitialTheme = () => {
    const stored = localStorage.getItem('app-theme');
    if (stored === 'light' || stored === 'dark') {
      return stored;
    }
    // no stored value, fall back to system preference
    const prefersDark = window.matchMedia?.('(prefers-color-scheme: dark)').matches;
    return prefersDark ? 'dark' : 'light';
  };

  const [theme, setTheme] = useState(getInitialTheme);

  // 3) sync <body> class and localStorage whenever theme changes
  useEffect(() => {
    document.body.classList.toggle('dark-mode', theme === 'dark');
    try {
      localStorage.setItem('app-theme', theme);
    } catch (err) {
      // localStorage might be disabled/blocked — fail silently
      console.warn('Could not persist theme choice', err);
    }
  }, [theme]);

  // 4) toggle helper
  const toggleTheme = () => {
    setTheme(curr => (curr === 'light' ? 'dark' : 'light'));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}
